/**
 * PB-FND-74 — Design Library field plugin (registry adapter).
 * Extracted from pb-field-runtime; wired via createDesignLibraryAdapter(deps).
 * Row-scoped DL (FND-64) and graceful empty (FND-71) stay in pb-design-library.js.
 */

export function renderDesignLibraryPreviewStage() {
  return (
    '<div class="pb-dl-preview-stage">' +
    '<div class="pb-dl-preview-empty">Select a design to preview.</div>' +
    '<div class="pb-dl-preview-scratch" aria-live="polite">' +
    '<div class="pb-dl-preview-scratch-card">Original design</div>' +
    '<p class="pb-dl-preview-scratch-msg">Your item will be created from scratch.</p>' +
    '</div>' +
    '<img class="pb-dl-preview-img" alt="" width="300" height="300" loading="lazy" style="display:none;">' +
    '</div>'
  );
}

/**
 * @param {object} deps — shared field-runtime helpers (avoids circular mega-body)
 */
export function createDesignLibraryAdapter(deps) {
  const {
    fieldTypeLower,
    resolveEsc,
    settingsToString,
    renderControlShell,
    delegateInitStep,
  } = deps;

  return {
    id: 'design-library',
    matches(field) {
      return fieldTypeLower(field).includes('design library');
    },
    renderStep(ctx) {
      const field = ctx.field;
      const esc = resolveEsc(ctx);
      const settingsStr = settingsToString(field.settings);
      const innerHtml =
        '<div class="pb-dl-wrap pb-dl-layout-carousel" data-pb-dl-label="' +
        esc(field.label) +
        '" data-settings="' +
        esc(settingsStr) +
        '">' +
        '<div class="pb-dl-loading" style="display:none;" aria-live="polite">' +
        '<span class="pb-dl-spinner" aria-hidden="true"></span>' +
        '<p class="pb-dl-loading-msg">Finding your designs…</p>' +
        '</div>' +
        '<div class="pb-dl-grid-wrap" style="display:none;">' +
        '<div class="pb-dl-grid pb-design-list"></div>' +
        '</div>' +
        '<input type="hidden" class="builder-required pb-dl-required" data-label="' +
        esc(field.label) +
        '" data-required="true" data-valid="false" value="">' +
        '</div>';
      return {
        controlHtml: renderControlShell(field, innerHtml, ctx),
        imageHtml: renderDesignLibraryPreviewStage(),
        stepAttrs: ' data-design-library="true"',
        extraClasses: '',
      };
    },
    initStep(stepEl) {
      delegateInitStep(stepEl, '.pb-dl-wrap', function (wrap) {
        if (window.PBDesignLibrary?.initWrap) window.PBDesignLibrary.initWrap(wrap);
      });
    },
    validateStep(stepEl) {
      if (typeof window !== 'undefined' && window.PBDesignLibrary?.validateStep) {
        return window.PBDesignLibrary.validateStep(stepEl);
      }
      return true;
    },
    hydrateStep(stepEl) {
      delegateInitStep(stepEl, '.pb-dl-wrap', function (wrap) {
        if (window.PBDesignLibrary?.initWrap) window.PBDesignLibrary.initWrap(wrap, { force: false });
        if (window.PBDesignLibrary?.hydrateCartEdit) {
          const root = stepEl.closest('#main-flow-container, #sub-flow-container');
          if (root) window.PBDesignLibrary.hydrateCartEdit('#' + root.id);
        }
      });
    },
    flushStep(stepEl) {
      if (typeof window !== 'undefined' && window.PBDesignLibrary?.flushCatalogStateForStep) {
        window.PBDesignLibrary.flushCatalogStateForStep(stepEl);
      }
    },
  };
}
